import api from './api';

export const getStrategies = () => api.get('/strategies');

export const getCustomStrategies = () => api.get('/strategies/custom');

export const getStrategyTemplates = () => api.get('/strategies/templates');

export const getStrategyCatalog = () => api.get('/strategies/catalog');

export const getStrategyCatalogAdmin = () => api.get('/strategies/catalog/admin');

export const updateStrategy = (id, data) =>
  api.put(`/strategies/${id}`, data);

export const createCatalogStrategy = (data) =>
  api.post('/strategies/catalog', data);

export const updateCatalogStrategy = (id, data) =>
  api.put(`/strategies/catalog/${id}`, data);

export const deleteCatalogStrategy = (id) =>
  api.delete(`/strategies/catalog/${id}`);

export const getAccountStrategies = () =>
  api.get('/strategies/account-strategies');

export const updateCustomStrategy = (id, data) =>
  api.put(`/strategies/custom/${id}`, data);

export const createAccountStrategy = (data) =>
  api.post('/strategies/account-strategies', data);

export const toggleAccountStrategy = (id) =>
  api.patch(`/strategies/account-strategies/${id}/toggle`);

export const updateAccountStrategySettings = (id, data) =>
  api.patch(`/strategies/account-strategies/${id}/settings`, data);

export const getAutoTradeStatus = (params) =>
  api.get('/strategies/auto-trade/status', { params });

export const setAiGuidedTrading = (data) => {
  const tradingAccountId = data?.trading_account_id;
  return api.patch('/strategies/auto-trade/ai-guided', data, {
    params: tradingAccountId ? { trading_account_id: tradingAccountId } : undefined,
  });
};

export const getAutoTradeEffectiveState = (params) =>
  api.get('/strategies/auto-trade/effective-state', { params });

export const getAutoTradeRuns = (params) =>
  api.get('/strategies/auto-trade/runs', { params });

export const toggleAutoTrade = (data) =>
  api.post('/strategies/auto-trade/toggle', data);

export const toggleAutoTradeScope = (data) =>
  api.post('/strategies/auto-trade/scope-toggle', data);

export const setAutoTradeScopeInterval = (data) =>
  api.post('/strategies/auto-trade/scope-interval', data);

export const setAutoTradePaperMode = (data) =>
  api.post('/strategies/auto-trade/paper-mode', data);

export const getAlerts = (params) => api.get('/strategies/alerts', { params });

export const updateAlertPreferences = (data) =>
  api.put('/strategies/alerts/preferences', data);

export const getSignalsAnalysis = (symbol) =>
  api.get(`/strategies/signals/analysis?symbol=${symbol}`);

export const toggleSignalScan = (data) =>
  api.post('/strategies/signals/scan/toggle', data);

export const runCustomBacktest = (customId, data) =>
  api.post(`/strategies/custom/${customId}/backtest`, data);

export const getExecutionOverview = () => api.get('/execution/overview');

export const getExecutionJobs = (params) =>
  api.get('/execution/jobs', { params });

// Unified audit history of what the system decided and why. Powers the chart
// decision lane so WAITs, guard blocks and execution blocks are visible where
// the operator is actually looking, instead of only in the database.
export const getDecisionTimeline = (params = {}) =>
  api.get('/strategies/decision-timeline', { params });
